var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var FileTooLargeException = /** @class */ (function (_super) {
    __extends(FileTooLargeException, _super);
    function FileTooLargeException() {
        var _this = _super.call(this, 'File is too large') || this;
        _this.name = 'FileTooLargeException';
        Object.setPrototypeOf(_this, FileTooLargeException.prototype);
        return _this;
    }
    return FileTooLargeException;
}(Error));
export { FileTooLargeException };
var InvalidFileTypeException = /** @class */ (function (_super) {
    __extends(InvalidFileTypeException, _super);
    function InvalidFileTypeException() {
        var _this = _super.call(this, 'The given file type is invalid') || this;
        _this.name = 'InvalidFileTypeException';
        Object.setPrototypeOf(_this, InvalidFileTypeException.prototype);
        return _this;
    }
    return InvalidFileTypeException;
}(Error));
export { InvalidFileTypeException };
